import { useState, useEffect, useMemo } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { DEVICE_TYPE } from "../../utils/constants";

interface ImageComponentProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  fallBackImage?: React.JSX.Element;
  customClass?: string;
  shrinkOnAnimate?: boolean;
}

const CustomNetworkImage: React.FC<ImageComponentProps> = ({
  src,
  alt,
  style,
  fallBackImage,
  customClass = "",
 shrinkOnAnimate = false,
}) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const cmsImages = useAppSelector((state) => state.CmsSlice.cmsImages);
  const deviceType = useDeviceDetection();

  const imgUrl = useMemo(() => {
    if (
      (deviceType === DEVICE_TYPE.MOBILE ||
        deviceType === DEVICE_TYPE.PWA_MOBILE) &&
      cmsImages &&
      cmsImages.length > 0
    ) {
      const cmsImage = cmsImages.find((i) => i.key === src);
      return cmsImage ? cmsImage.mobile : src;
    }
    return src;
  }, [deviceType, src, cmsImages]);

  useEffect(() => {
    const image = new Image();
    image.src = imgUrl;

    image.onload = () => {
      setIsLoading(false);
      setHasError(false);
    };

    image.onerror = () => {
      setHasError(true);
      setIsLoading(false);
    };
  }, [imgUrl]);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      {!hasError ? (
        <img
          src={imgUrl}
          alt={alt}
          style={{
            ...style,
            ...(shrinkOnAnimate?{
               width: "100%",   
            height: "100%",   
            objectFit: "contain",
            }:{}),
            visibility: isLoading ? "hidden" : "initial",
            transition: "opacity 0.3s ease",
            opacity: isLoading ? 0 : 1,
          }}
        />
      ) : (
        <div
          className={customClass ? customClass : ""}
          style={{ ...style, height: "auto", textAlign: "center" }}
        >
          {fallBackImage}
        </div>
      )}
    </div>
  );
};

export default CustomNetworkImage;
